<template lang="pug">
    div(v-if="listData!==undefined")
        div(v-for="(item, index) in listData", :key="item" v-if="index < maxShow")
            Tag(:color="tagColors[index]")
                | {{ item }}
        Button(
            size="small"
            v-if="listData.length > maxShow"
            @click="showResult = !showResult"
            icon="ios-eye"
        )
            | view
        Modal(:title="title" v-model="showResult")
            .poptipExplain
                p(v-for="data in listData") {{ data }}
</template>
<script>
export default {
    name: "TagList",
    props: ["listData", "maxShow", "title", "width", "colors"],
    components: {},
    watch: {},
    created() {},
    data() {
        return {
            showResult: false
        };
    },
    methods: {},
    mounted() {
        // console.log(this.listData);
    },
    computed: {
        tagColors() {
            return this.colors && this.listData !== undefined ? this.colors : this.listData.map(e => "default");
        }
    }
};
</script>
<style scoped>
.poptipExplain {
    overflow: auto;
    white-space: normal;
    word-break: break-all;
    line-height: 25px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/components/TagList.vue